import { defaultTimes } from "@/modules/variables";

const sortArrs = (baseArr, sortArr) => {
    const sorted = baseArr.reduce((sortArray, defaultTime) => {
        if (!sortArr.includes(defaultTime)) {
            sortArray.push(defaultTime);
        }

        return sortArray;
    }, []);

    return sorted;
};

export default {
    namespaced: true,

    state: {
        amData: [],
        pmData: [],
        date: {
            day: null,
            month: null,
            year: null,
        },
    },
    getters: {
        getAmTimes: (state) => state.amData,
        getPmTimes: (state) => state.pmData,
        getTimeSelectDate: (state) => state.date,
    },
    mutations: {
        SET_TIMES_DATA: (state, data) => {
            state.date = data.selectedDate;
            const defaultAM = defaultTimes.slice(0, 7);
            const defaultPM = defaultTimes.slice(7, 17);

            if (data.dayEvent) {
                const reservedTimes = data.dayEvent.time.data.map((element) => element.time);

                state.amData = sortArrs(defaultAM, reservedTimes);
                state.pmData = sortArrs(defaultPM, reservedTimes);
            } else {
                state.amData = defaultAM;
                state.pmData = defaultPM;
            }
        },
        RESET_TIMES_DATA: (state) => {
            state.amData = [];
            state.pmData = [];
            state.date = { day: null, month: null, year: null };
        },
    },
};
